import React from "react";
import {Delete, translate} from "admin-on-rest";
import AdminsDataList from "./AdminsDataList";
import AdminCreateForm from "./AdminsCreateForm";
import AdminEditForm from "./AdminsEditForm";

///////////////////// LIST ALL ADMINS /////////////////////
export const AdminList = props => <AdminsDataList {...props} />;

///////////////////// CREATE NEW ADMINS /////////////////////
export const AdminCreate = props => <AdminCreateForm {...props} />;

///////////////////// UPDATE ADMINS /////////////////////
export const AdminEdit = props => <AdminEditForm {...props} />;

///////////////////// DELETE ADMINS /////////////////////
const AdminDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.email}`}
  </span>
);

const AdminDeleteTitle = translate(AdminDeleteTitleBase);

export const AdminDelete = props => (
  <Delete {...props} title={<AdminDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/index.js